import { http } from "@/lib/http";

import type {
  VpnConnection,
  VpnConnectionCreateRequest,
  VpnConnectionUpdateRequest,
  VpnPeerConfig,
} from "./types";

export async function listVpnConnections(): Promise<VpnConnection[]> {
  const { data } = await http.get<VpnConnection[]>("/network/vpn-connections");
  return data;
}

export async function getVpnConnection(
  connectionId: string,
): Promise<VpnConnection> {
  const { data } = await http.get<VpnConnection>(
    `/network/vpn-connections/${connectionId}`,
  );
  return data;
}

export async function createVpnConnection(
  payload: VpnConnectionCreateRequest,
): Promise<VpnConnection> {
  const { data } = await http.post<VpnConnection>(
    "/network/vpn-connections",
    payload,
  );
  return data;
}

export async function updateVpnConnection(
  connectionId: string,
  payload: VpnConnectionUpdateRequest,
): Promise<VpnConnection> {
  const { data } = await http.put<VpnConnection>(
    `/network/vpn-connections/${connectionId}`,
    payload,
  );
  return data;
}

export async function deleteVpnConnection(connectionId: string): Promise<void> {
  await http.delete(`/network/vpn-connections/${connectionId}`);
}

export async function getVpnPeerConfig(
  connectionId: string,
): Promise<VpnPeerConfig> {
  const { data } = await http.get<VpnPeerConfig>(
    `/network/vpn-connections/${connectionId}/peer-config`,
  );
  return data;
}
